import { isPlainObject } from 'lodash-es'
import { useEncryptApiFileData } from '@/composables/useEncryptApiFileData'
import { useToken } from '../composables/useToken'
import { fetchBufferData } from './fetchBufferData'
import type { RequestOptions } from './http'

// 这些接口在用户未登录的时候，请求缓存文件，已登录后，带着token请求原接口
const dynamicUrls = [
  '/app-api/activity/index/preview',
  '/app-api/agent/share/activity/inviteGrade',
  '/app-api/activity/index/sideBarList',
  '/app-api/activity/index/list',
  '/app-api/member/banner/list',
  '/app-api/member/support-area/config',
  '/app-api/member/support-area/list'
  // ......
]

/**
 * HTTP API 到文件拦截器
 * 优先使用本地缓存的文件数据，减少网络请求
 * @param url 请求URL
 * @param opts 请求选项
 * @returns 如果找到缓存文件则返回数据，否则返回null
 */
export async function httpApiToFileInterceptor(
  url: string,
  opts: RequestOptions
): Promise<any | null> {
  const { getApiFileData } = useEncryptApiFileData()
  const apiFileData = await getApiFileData()
  const { isLoggedIn } = useToken()

  // 如果用户已登录且是动态URL，直接返回null使用原接口
  if (isLoggedIn.value && dynamicUrls.includes(url)) {
    return null
  }

  // 特定API需要添加 /h5 后缀
  if (
    [
      '/app-api/member/banner/list',
      '/app-api/system/theme/sub-list',
      '/app-api/system/lang-data/release-list',
      '/app-api/account/revolvingLantern/list',
      '/app-api/release-list/country',
      '/app-api/activity/index/list',
      '/app-api/activity/index/sideBarList',
      '/app-api/system/versionManagement/lastVersion',
      '/app-api/agent/share/activity/inviteGrade',
      '/app-api/activity/index/preview'
    ].includes(url)
  ) {
    url += '/h5'

    // banner列表需要根据imgType添加额外路径
    if (['/app-api/member/banner/list/h5'].includes(url)) {
      const imgType = (opts.body as any)?.model?.imgType
      if (imgType) {
        url += `/${imgType}`
      }
    }
  }

  // 客服列表需要根据customerType添加路径
  if (['/app-api/member/customer/service/list'].includes(url)) {
    const customerType = (opts.body as any)?.model?.customerType
    if (customerType) {
      url += `/${customerType}`
    }
  }

  // 查找对应的API文件数据
  const apiFile = apiFileData.find(({ apiName }) => {
    return apiName === url
  })

  if (apiFile?.memoryAddress) {
    try {
      const res = await fetchBufferData(
        `${import.meta.env.VITE_S3_URL}/${apiFile.memoryAddress}?v=${Math.random().toString(32)}`.replace(
          /([^:]\/)\/+/g,
          '$1'
        )
      )
      if (isPlainObject(res)) {
        console.log('✅ ApiFile缓存命中:', url, apiFile.memoryAddress, opts, res)
        return res
      }
    } catch (error) {
      console.warn('⚠️ ApiFile缓存读取失败:', url, error)
    }
  }

  return null
}
